import {createAction} from 'redux-actions'
import {GET_VERIFYING_CREDS} from '@rambler-id/transport'
import {apiV3} from 'utils/transport'
import {sentryReact as Sentry} from '@rambler-id/sentry'
import {throwError} from 'containers/App/actions'

export const updateVerifyingCreds = createAction('UPDATE_VERIFYING_DATA')

export const loadVerifyingCreds = (method) => async (dispatch) => {
  try {
    const {creds, needCheck} = await apiV3(`/legacy/${GET_VERIFYING_CREDS}`, {
      ...(method ? {method} : {})
    })

    if (!creds) {
      return
    }

    dispatch(updateVerifyingCreds({creds, needCheck}))
  } catch (error) {
    Sentry.captureException(error)
    dispatch(
      throwError(
        'По техническим причинам отображены не все данные. При необходимости перезагрузите страницу.',
        error
      )
    )
  }
}
